import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../environments/environment';

@Component({
    selector: 'burncase-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    title = 'BurnCase';

    constructor(public translate: TranslateService) {
        translate.addLangs(['en', 'cz']);
        // translate.setDefaultLang('en');
        translate.use(environment.language);
        // auto detect
        // const browserLang = translate.getBrowserLang();
        // translate.use(browserLang.match(/en|cz/) ? browserLang : 'en');
    }

}
